import {SemanticLegendByMetric} from 'src/generated/graphql';

import {
  BucketCustomization,
  SemanticLegendSettingsWithCategoricalConfig,
} from '../../types';
import {SemanticLegendPalette} from './colorPalettes';
import {getColorFromValue} from './getDefaultBucketColors';

export function parseBucketsFromSemanticLegendByMetric(
  semanticLegendByMetric: SemanticLegendByMetric,
  semanticLegendPalette: SemanticLegendPalette
) {
  // we need to construct the buckets based off of the semantic legend settings
  const bucketDifferential =
    (semanticLegendByMetric?.bucketUpperBounds?.[1] ?? 0) -
    (semanticLegendByMetric?.bucketUpperBounds?.[0] ?? 0);

  const buckets =
    semanticLegendByMetric?.bucketUpperBounds?.map(
      (bucketUpperBounds, index) => ({
        bucketMin: bucketUpperBounds - bucketDifferential,
        bucketMax: bucketUpperBounds,
        color: getColorFromValue(
          index,
          semanticLegendByMetric?.bucketUpperBounds?.length ?? 0,
          semanticLegendPalette
        ),
      })
    ) ?? [];
  const bucketCustomizations: Record<number, BucketCustomization> = {};
  Object.entries(semanticLegendByMetric?.customColors ?? {}).forEach(
    ([_, customization]) => {
      bucketCustomizations[parseInt(customization.bucketNumber)] = {
        color: customization.colorHex,
      };
    }
  );

  return {
    buckets,
    bucketCustomizations,
  };
}

export function parseBucketsFromSemanticLegendSettings(
  semanticLegendSettings: SemanticLegendSettingsWithCategoricalConfig
) {
  const customColors = [];
  for (const [bucketNumber, bucket] of Object.entries(
    semanticLegendSettings?.bucketCustomizations ?? {}
  )) {
    if (bucket.color) {
      customColors.push(`${parseInt(bucketNumber)}:${bucket.color}`);
    }
  }
  const bucketUpperBounds = semanticLegendSettings?.buckets?.map(
    (bucket, index) => {
      if (semanticLegendSettings?.bucketCustomizations?.[index]?.bucketMax) {
        return semanticLegendSettings?.bucketCustomizations?.[index]?.bucketMax;
      }
      return bucket.bucketMax;
    }
  );
  return {customColors, bucketUpperBounds};
}
